import { render, staticRenderFns } from "./AppleLabelGridItem.vue?vue&type=template&id=ade6a724&"
import script from "./AppleLabelGridItem.vue?vue&type=script&lang=js&"
export * from "./AppleLabelGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports